import { Divider } from '@mantine/core'
import DividerClasses from './styles.module.css'

export default Divider.extend({
    defaultProps: {
        color: 'var(--gm-background-bg-tonal)',
    },
    classNames: DividerClasses,
})
